import React from 'react';

type Props = {
  src: string;
  style?: React.CSSProperties;
};

export const Image: React.FC<Props> = ({src, style}) => {
  return (
    <img
      src={src}
      style={{
        width: 90,
        height: 90,
        border: '1px solid #DEDEDE',
        borderRadius: 12,
        marginRight: 20,
        ...style,
      }}
    />
  );
};
